// Web Applications Category
import { ShowcaseCategory } from "../showcase-types.ts";
import { ICONS } from "../showcase-icons.ts";

export const webApplicationsCategory: ShowcaseCategory = {
  id: "web-applications",
  title: {
    en: "Web Applications",
    lv: "Tīmekļa Lietojumprogrammas",
    it: "Applicazioni Web",
  },
  subtitle: {
    en: "Interactive web applications for education and engagement",
    lv: "Interaktīvas tīmekļa lietojumprogrammas izglītībai un iesaistei",
    it: "Applicazioni web interattive per l'istruzione e il coinvolgimento",
  },
  iconGradient: "from-green-500 to-emerald-600",
  iconSvgPath: ICONS.globe,
  projects: [
    {
      id: "latvija-geography-guesser",
      title: {
        en: "Latvija Geography Guesser",
        lv: "Latvijas Ģeogrāfijas Minētājs",
        it: "Indovina la Geografia della Lettonia",
      },
      industry: {
        en: "Educational Web Application",
        lv: "Izglītojoša Tīmekļa Lietojumprogramma",
        it: "Applicazione Web Educativa",
      },
      description: {
        en:
          "We developed an interactive geographical learning game that helps users test and improve their knowledge of Latvian locations. The application presents users with location names and challenges them to identify the correct position on a map, providing immediate feedback and scoring to make learning geography engaging and fun.",
        lv:
          "Mēs izstrādājām interaktīvu ģeogrāfisko mācību spēli, kas palīdz lietotājiem pārbaudīt un uzlabot savas zināšanas par Latvijas vietām. Lietojumprogramma piedāvā lietotājiem vietu nosaukumus un izaicina viņus identificēt pareizo pozīciju kartē, sniedzot tūlītēju atgriezenisko saiti un punktu skaitīšanu, lai padarītu ģeogrāfijas mācīšanos aizraujošu un jautru.",
        it:
          "Abbiamo sviluppato un gioco di apprendimento geografico interattivo che aiuta gli utenti a testare e migliorare la loro conoscenza delle località lettoni. L'applicazione presenta agli utenti i nomi delle località e li sfida a identificare la posizione corretta su una mappa, fornendo feedback immediato e punteggio per rendere l'apprendimento della geografia coinvolgente e divertente.",
      },
      keyOutcomes: [
        {
          text: {
            en: "Interactive map-based learning interface",
            lv: "Interaktīva kartes bāzēta mācību saskarne",
            it: "Interfaccia di apprendimento interattiva basata su mappa",
          },
        },
        {
          text: {
            en: "Real-time scoring and accuracy feedback",
            lv:
              "Reāllaika punktu skaitīšana un precizitātes atgriezeniskā saite",
            it: "Punteggio in tempo reale e feedback sulla precisione",
          },
        },
        {
          text: {
            en: "Comprehensive coverage of Latvian locations",
            lv: "Visaptveroša Latvijas vietu pārklājums",
            it: "Copertura completa delle località lettoni",
          },
        },
      ],
      techBadges: [
        { name: "JavaScript", colorClass: "bg-yellow-100 text-yellow-700" },
        { name: "Leaflet Maps", colorClass: "bg-green-100 text-green-700" },
        { name: "OpenStreetMap", colorClass: "bg-blue-100 text-blue-700" },
        {
          name: "Responsive Design",
          colorClass: "bg-purple-100 text-purple-700",
        },
      ],
      metric: {
        value: "100%",
        label: { en: "Free", lv: "Bezmaksas", it: "Gratuito" },
        sublabel: {
          en: "educational tool",
          lv: "izglītības rīks",
          it: "strumento educativo",
        },
        colorClass: "text-green-600",
        bgGradient: "from-green-50 to-emerald-50",
      },
      iconGradient: "from-green-500 to-emerald-600",
      iconSvgPath: ICONS.globe,
      screenshot: "/assets/showcase/latvija/latvija.dammi.lv_screenshot_1.png",
    },
    {
      id: "brescia-geography-guesser",
      title: {
        en: "Brescia Geography Guesser",
        lv: "Brešas Ģeogrāfijas Minētājs",
        it: "Geo Brescia - Indovina la Geografia",
      },
      industry: {
        en: "Educational Web Application",
        lv: "Izglītojoša Tīmekļa Lietojumprogramma",
        it: "Applicazione Web Educativa",
      },
      description: {
        en:
          "We created an engaging geographical learning tool focused on the province of Brescia, Italy. This interactive application helps users discover and memorize the locations of towns and landmarks throughout the Brescia region, combining education with gamification to create an enjoyable learning experience about local geography.",
        lv:
          "Mēs izveidojām aizraujošu ģeogrāfisko mācību rīku, kas koncentrējas uz Brešas provinces, Itālijā. Šī interaktīvā lietojumprogramma palīdz lietotājiem atklāt un iegaumēt pilsētu un orientieri atrašanās vietas visā Brešas reģionā, apvienojot izglītību ar gamifikāciju, lai radītu patīkamu mācību pieredzi par vietējo ģeogrāfiju.",
        it:
          "Abbiamo creato uno strumento di apprendimento geografico coinvolgente incentrato sulla provincia di Brescia, Italia. Questa applicazione interattiva aiuta gli utenti a scoprire e memorizzare le posizioni di città e punti di riferimento in tutta la regione bresciana, combinando educazione e gamification per creare un'esperienza di apprendimento piacevole sulla geografia locale.",
      },
      keyOutcomes: [
        {
          text: {
            en: "Detailed coverage of Brescia province locations",
            lv: "Detalizēts Brešas provinces vietu pārklājums",
            it:
              "Copertura dettagliata delle località della provincia di Brescia",
          },
        },
        {
          text: {
            en: "Gamified learning with instant feedback",
            lv: "Gamificēta mācīšanās ar tūlītēju atgriezenisko saiti",
            it: "Apprendimento gamificato con feedback istantaneo",
          },
        },
        {
          text: {
            en: "Progressive difficulty for effective learning",
            lv: "Progresīva grūtība efektīvai mācīšanai",
            it: "Difficoltà progressiva per un apprendimento efficace",
          },
        },
      ],
      techBadges: [
        { name: "JavaScript", colorClass: "bg-yellow-100 text-yellow-700" },
        { name: "Leaflet Maps", colorClass: "bg-green-100 text-green-700" },
        { name: "OpenStreetMap", colorClass: "bg-blue-100 text-blue-700" },
        {
          name: "Responsive Design",
          colorClass: "bg-purple-100 text-purple-700",
        },
      ],
      metric: {
        value: "10+",
        label: { en: "Rounds", lv: "Kārtas", it: "Round" },
        sublabel: {
          en: "of progressive learning",
          lv: "progresīvas mācīšanās",
          it: "di apprendimento progressivo",
        },
        colorClass: "text-orange-600",
        bgGradient: "from-orange-50 to-amber-50",
      },
      iconGradient: "from-orange-500 to-amber-600",
      iconSvgPath: ICONS.globe,
      screenshot: "/assets/showcase/brescia/brescia.dammi.lv_screenshot_1.png",
    },
    {
      id: "rpgmeet-app",
      title: {
        en: "RPGMeet.app",
        lv: "RPGMeet.app",
        it: "RPGMeet.app",
      },
      industry: {
        en: "Community Web Application",
        lv: "Kopienas Tīmekļa Lietojumprogramma",
        it: "Applicazione Web per Community",
      },
      description: {
        en:
          "We built RPGMeet.app, a platform connecting tabletop RPG enthusiasts to find local gaming groups and events. The application helps players discover nearby RPG sessions, organize game nights, and build communities around their favorite tabletop games—making it easier than ever to find your next adventure.",
        lv:
          "Mēs izveidojām RPGMeet.app, platformu, kas savieno galda RPG entuziastus, lai atrastu vietējās spēļu grupas un pasākumus. Lietojumprogramma palīdz spēlētājiem atklāt tuvumā esošas RPG sesijas, organizēt spēļu vakarus un veidot kopienas ap savām iecienītākajām galda spēlēm—padarot vieglāku nekā jebkad atrast savu nākamo piedzīvojumu.",
        it:
          "Abbiamo creato RPGMeet.app, una piattaforma che connette gli appassionati di giochi di ruolo da tavolo per trovare gruppi di gioco ed eventi locali. L'applicazione aiuta i giocatori a scoprire sessioni RPG nelle vicinanze, organizzare serate di gioco e costruire comunità attorno ai loro giochi da tavolo preferiti—rendendo più facile che mai trovare la prossima avventura.",
      },
      keyOutcomes: [
        {
          text: {
            en: "Location-based discovery of RPG groups and events",
            lv: "Uz atrašanās vietu balstīta RPG grupu un pasākumu meklēšana",
            it: "Scoperta di gruppi ed eventi RPG basata sulla posizione",
          },
        },
        {
          text: {
            en: "Community building tools for tabletop gaming enthusiasts",
            lv: "Kopienas veidošanas rīki galda spēļu entuziastiem",
            it:
              "Strumenti di costruzione della comunità per gli appassionati di giochi da tavolo",
          },
        },
        {
          text: {
            en: "Event organization and scheduling features",
            lv: "Pasākumu organizēšanas un plānošanas funkcijas",
            it: "Funzionalità di organizzazione e pianificazione eventi",
          },
        },
      ],
      techBadges: [
        { name: "Next.js", colorClass: "bg-gray-100 text-gray-700" },
        { name: "TypeScript", colorClass: "bg-blue-100 text-blue-700" },
        { name: "Tailwind CSS", colorClass: "bg-cyan-100 text-cyan-700" },
        { name: "Geolocation", colorClass: "bg-green-100 text-green-700" },
      ],
      metric: {
        value: "100%",
        label: { en: "Free", lv: "Bezmaksas", it: "Gratuito" },
        sublabel: {
          en: "community platform",
          lv: "kopienas platforma",
          it: "piattaforma community",
        },
        colorClass: "text-purple-600",
        bgGradient: "from-purple-50 to-pink-50",
      },
      iconGradient: "from-purple-500 to-pink-600",
      iconSvgPath: ICONS.globe,
      screenshot: "/assets/showcase/rpgmeet/rpgmeet.app_.png",
    },
  ],
};
